import {Button, Card} from 'react-bootstrap';
import createReactClass from 'create-react-class';

import QACandidatePanelBottomMailModal from './QACandidatePanelBottomMailModal.js';
import CONFIG from '../global/libs/CONFIG.js';
import {DESIGN} from '../global/libs/CONFIG.js';
import newlineToBr from '../global/libs/newlineToBr.js';
import PropTypes from 'prop-types';

let QACandidatePanelBottom = createReactClass({
  propTypes: {
    isSorry: PropTypes.bool,
    question: PropTypes.string,
    logId: PropTypes.number,
    cgId: PropTypes.string
  },

  gotoAdminAppendQaPage() {
    const adminAppendUrl = CONFIG.SERVERURL + '/admin/qa_data/qa/add/';
    window.open(adminAppendUrl, '_blank');
    return false;
  },

  render() {
    let thisReturn = <span />;

    if (CONFIG.INQUIRY_MAIL) {
      if (this.props.isSorry) {
        thisReturn = (
          <div style={{width: '100%'}}>
            {CONFIG.ENABLE_INQUIRY ? (
              <div style={{marginBottom: '12px'}}>
                <QACandidatePanelBottomMailModal
                  question={this.props.question}
                  logId={this.props.logId}
                  cgId={this.props.cgId}
                />
              </div>
            ) : null}
            <Card style={{fontSize: 'large', margin: '1rem 0', padding: '1rem'}}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {DESIGN.SORRY}
                <span dangerouslySetInnerHTML={newlineToBr(DESIGN.SORRY_MESSAGE)} style={{textAlign: 'left'}} />
              </div>
            </Card>
          </div>
        );
      } else {
        thisReturn = (
          <div style={{width: '100%'}}>
            {CONFIG.ENABLE_INQUIRY && CONFIG.DISPLAY_INQUIRY_BUTTON_ALWAYS ? (
              <div style={{marginBottom: '12px'}}>
                <QACandidatePanelBottomMailModal
                  question={this.props.question}
                  logId={this.props.logId}
                  cgId={this.props.cgId}
                />
              </div>
            ) : null}
            <Card style={{fontSize: 'large', margin: '1rem 0', padding: '1rem'}}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {DESIGN.DEFAULT}
                <span dangerouslySetInnerHTML={newlineToBr(DESIGN.NO_CONFIDENCE_MESSAGE)} style={{textAlign: 'left'}} />
              </div>
            </Card>
          </div>
        );
      }
    } else {
      thisReturn = (
        <Card style={{fontSize: 'large'}}>
          <span dangerouslySetInnerHTML={newlineToBr(DESIGN.SORRY_MESSAGE)} style={{textAlign: 'left'}} />
          <Button variant="primary" onClick={this.gotoAdminAppendQaPage}>
            新しい質問を登録する
          </Button>
        </Card>
      );
    }

    return thisReturn;
  }
});

export default QACandidatePanelBottom;
